<template>
  <div class="github-callback" />
</template>

<script setup>
import { getCurrentInstance, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const { proxy } = getCurrentInstance()

onMounted(async () => {
  const code = route.query.code

  if (!code) {
    return
  }

  proxy.$loadingState.start('Connecting to GitHub, please do not close this tab...')

  if (window.opener) {
    window.opener.postMessage({ type: 'github-auth', code }, '*')
    setTimeout(() => {
      proxy.$loadingState.stop()
      window.close()
    }, 5000)
  }
})
</script>
